import { UNOAPP_AUCTIONS_API_TOKEN, UNOAPP_AUCTIONS_API_URL, UNOAPP_LABATT_CORONA_BUSINESS_ID } from './env.js'
import { Fetch } from './fetch'

const _fetch = new Fetch({ baseURL: UNOAPP_AUCTIONS_API_URL, headers: { 'api-token': UNOAPP_AUCTIONS_API_TOKEN, 'business-id': UNOAPP_LABATT_CORONA_BUSINESS_ID } })

export const AUCTIONS_API = {
  Auctions: {
    /**
     *
     * Makes a call to UNOapp Auction API to get all auctions
     * @returns {Promise}
     */
    getAllAuctions () {
      return _fetch.get({
        url: '/api/v1/auction?is_published=1'
      })
    },
    /**
     *
     * Makes a call to UNOapp Auction API to get details of an active auction item
     * @returns {Promise}
     * @param {*} auctionId
     */
    getLiveAuctionItemsForAuctionById (auctionId) {
      return _fetch.get({
        url: `/api/v1/auction/live/${auctionId}`
      })
    },
    /**
     * Make a call to auctions api and get
     *
     * @param {*} auctionItemId
     * @returns
     */
    getAuctionItemById (auctionItemId) {
      return _fetch.get({
        url: `/api/v1/auction/item/${auctionItemId}`
      })
    }
  },
  Bids: {
    /**
     * Makes a call to UNOapp Auction API to place a bid on an auction item
     * @param {*} body  {user_id,business_uuid,auction_id,auction_item_id,bid_amount}
     * @returns {Promise}
     */
    addBids (body) {
      return _fetch.post({
        url: '/api/v1/bid',
        body
      })
    },

    /**
     * Makes a call to UNOapp Auction API to get all bids for auction Item
     *
     * @param {*} auctionId
     * @param {*} auctionItemId
     * @returns {Promise}
     */
    getAllBidsForAuctionItem (auctionId, auctionItemId) {
      return _fetch.get({
        url: `/api/v1/bid?auction_id=${auctionId}&auction_item_id=${auctionItemId}`
      })
    }
  },
  AutoBids: {
    /**
     * Creates an autobid setting for a user and auction-item.
     *
     * @param {*} body {user_id,auction_id,auction_item_id,bid_max,bid_min,bid_increments}
     * @returns
     */
    createAutoBidSettings (body) {
      return _fetch.post({
        url: '/api/v1/autobid/settings',
        body
      })
    }
  },
  Subscriptions: {
    /**
    * Creates an autobid setting for a user and auction-item.
    *
    * @param {*} body {user_id,auction_id,auction_item_id,notify_details}
    * @returns
    */
    createASubscriptionForAuctionItem (body) {
      return _fetch.post({
        url: '/api/v1/auction/subscriptions',
        body
      })
    }
  },
  Localization: {
    getLocalizedData (refId, refType, lang = 'fr') {
      return _fetch.get({
        url: `/api/v1/auction/localization/?ref_id=${refId}&ref_type=${refType}&lang=${lang}`
      })
    }
  }
}
